export default __webpack_public_path__ + "static/media/colorPicker.png";